import { createAction, props } from '@ngrx/store';

export const classfieldCountSuccess = createAction(
  '[Category] Classfield Count Success',
  props<{ count: number }>()
);
